<template>
  <div
    class="backdrop"
    @click="Store.closeContactUsModal()"
    :class="{ active: Store.state.contactUsModal.open }"
  ></div>
</template>

<script>
export default {
  name: 'ContactUsBackdrop'
};
</script>

<style lang="scss" scoped>
.backdrop {
  background: rgba(0, 0, 0, 0.3);
  z-index: 900000;
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  transform: translateX(100%) translateY(0px);
  &.active {
    transform: translateX(0) translateY(0px);
  }
}
</style>
